module.exports = require('./helpers/bundle-url').getBundleURL('kXH6J') + "logo-dark.a922e36b.svg";